// Libs
import React, { Component } from 'react'
import { reduxForm, formValueSelector } from 'redux-form'
import _ from 'lodash'

// CSS
import './styles.scss'

// Components
import CaptureFilterSection from '../CaptureFilterSection'
import SideBar from '../../../../components/SideBar'

//Constansts
import { uf } from '../../constants'

// Options
// import { uf } from '../../constants'

class CaptureFilter extends Component {
  ifChecked = (preRequisiteSection, value, section) => {
    const { captureFilter, handleReset } = this.props

    if (captureFilter && !_.isEmpty(captureFilter.values)) {
      if (captureFilter.values[preRequisiteSection] && captureFilter.values[preRequisiteSection].indexOf(value) !== -1) {
        return true
      }
      if (captureFilter.values[section]) {
        handleReset(section)
        return false
      }
    }
  }

  render() {
    const { visible, handleOpen, handleClose, handleReset, form, captureFilter } = this.props
    const { ifChecked } = this

    return (
      <SideBar
        visible={visible}
        title="Filtros"
        button="Filtros"
        handleOpen={handleOpen}
        handleClose={handleClose}>
        <CaptureFilterSection
          type="input"
          name="search"
          title="Palavra Chave"
          form={form}
          captureFilter={captureFilter}
          handleReset={() => handleReset('search')} />
        <CaptureFilterSection
          type="checkbox"
          name="capturedStatus"
          title="Captação Status"
          form={form}
          captureFilter={captureFilter}
          options={[
            { label: 'Novo Processo', value: 'Novo Processo' }, { label: 'Arquivado', value: 'Arquivado' }, { label: 'Inserido', value: 'Inserido' }
          ]}
          handleReset={() => handleReset('capturedStatus')} />
        <CaptureFilterSection
          type="checkbox"
          name="partyType"
          title="Polo"
          form={form}
          captureFilter={captureFilter}
          options={[
            { label: 'Ativo', value: 'plaintiff' }, { label: 'Passivo', value: 'defendant' }
          ]}
          handleReset={() => handleReset('partyType')} />
        <CaptureFilterSection
          type="checkbox"
          name="systemCode"
          title="Código do Sistema"
          form={form}
          captureFilter={captureFilter}
          options={[
            { label: 'Sim', value: true }, { label: 'Não', value: false }
          ]}
          handleReset={() => handleReset('systemCode')} />
        <CaptureFilterSection
          type="checkbox"
          name="loss"
          title="Perda"
          form={form}
          captureFilter={captureFilter}
          options={[
            { label: 'Provável', value: 'likely' }, { label: 'Possível', value: 'possible' }, { label: 'Remota', value: 'remote' }, { label: 'Indefinida', value: null },
          ]}
          handleReset={() => handleReset('loss')} />
        <CaptureFilterSection
          type="radio"
          name="createdAt"
          title="Data de Captura"
          form={form}
          captureFilter={captureFilter}
          options={[
            { label: 'Hoje', value: 'today' },
            { label: 'Ontem', value: 'yesterday' },
            { label: 'Esta Semana', value: 'thisWeek' },
            { label: 'Semana Passada', value: 'lastWeek' },
            { label: 'Este Mês', value: 'thisMonth' },
            { label: 'Mês Passado', value: 'lastMonth' },
            { label: 'Este Ano', value: 'thisYear' },
            { label: 'Ano Passado', value: 'lastYear' },
            { label: 'Últimos 30 Dias', value: 'last30days' },
            { label: 'Últimos 60 Dias', value: 'last60days' },
            { label: 'Últimos 90 Dias', value: 'last90days' }
          ]}
          handleReset={() => handleReset('createdAt')} />
        <CaptureFilterSection
          type="radio"
          name="tags"
          title="Tags"
          form={form}
          captureFilter={captureFilter}
          options={[
            { label: 'Covid-19', value: 'covid' }
          ]}
          handleReset={() => handleReset('tags')} />
        <CaptureFilterSection
          type="checkbox"
          name="uf"
          title="UF"
          form={form}
          captureFilter={captureFilter}
          options={uf}
          handleReset={() => handleReset('uf')} />
      </SideBar>
    )
  }
}

CaptureFilter = reduxForm({
  form: 'captureFilter',
  destroyOnUnmount: false
})(CaptureFilter)

const selector = formValueSelector('captureFilter')

export default CaptureFilter
